module.exports = {
  model: { id: '', boarding_time: null, boarding_place: null, city: null, state: null },
}
